export default {"src":"/_next/static/media/visa-cof-white.e427110c.svg","height":170,"width":294,"blurWidth":0,"blurHeight":0};